module.exports = __webpack_public_path__ + "static/images/close-button.53cec88a49192b26fba3dd192940f432.svg";